import React, { useState } from "react";
import { useController } from "react-hook-form";
import DaumPostcode from "react-daum-postcode";

import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";

const Address = (props) => {
	const [findAddressModal, setFindAddressModal] = useState(false);

	const { control, name, setValue, readonly,handleAddress1Change,handleAddress2Change,card } = props; //required

	const postCode = useController({
		control,
		name: name["postCode"],
		// rules: validation,
	}).field;

	const address1 = useController({
		control,
		name: name["address1"],
		// rules: validation,
	}).field;

	const address2 = useController({
		control,
		name: name["address2"],
		// rules: validation,
	}).field;

	return (
		<>
			<div className="postcode-wrap">
				<button
					type="button"
					className="btn__postcode btn__outline angled"
					color="primary"
					onClick={() => setFindAddressModal(true)}
				>
					주소검색
				</button>
				<input
					type="text"
					value={
						postCode.value && address1.value
							? `(${postCode.value}) ${address1.value}`
							: ""
					}
					className="c__input"
					disabled
					placeholder="도로명 주소"
				/>
			</div>
			<input
				type="text"
				value={address2.value ? address2.value : ""}
				className="c__input f__item"
				onChange={(e) => {address2.onChange(e.target.value);handleAddress2Change(e.target.value, card)}}
				placeholder="상세주소"
				readOnly={readonly}
			/>
			<ModalTemplate
				title="주소검색"
				modalState={findAddressModal}
				setModalToggle={setFindAddressModal}
				height={550}
				width={500}
				className="findAddress-modal"
			>
				<div style={{ overflow: "hidden", borderRadius: "0px 0px 15px 15px" }}>
					<DaumPostcode
						style={{ height: "550px" }}
						onComplete={(e) => {
							setFindAddressModal(false);
							handleAddress1Change(e.address, card);
							setValue(name["postCode"], e.zonecode);
							setValue(name["address1"], e.address);
							
						}}
					/>
				</div>
			</ModalTemplate>
		</>
	);
};

export default Address;

Address.defaultProps = {
	className: "c__addressGroup",
};
